<template>
  <v-dialog v-model="openDialog" max-width="600">
    <v-card class="pa-4">
      <v-layout column>
        <v-card-title class="px-0">
          Confirm Carrier Insurance Certificate
        </v-card-title>
        <v-textarea
          rows="3"
          v-model="notes"
          label="Notes"
          auto-grow>
        </v-textarea>
        <v-card-actions>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent" @click="confirm()">Confirm</v-btn>
            <v-btn color="accent" flat @click="openDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';

export default {
  name: 'ConfirmInsuranceModal',
  props: ['value', 'companyId'],
  watch: {
    value() {
      this.openDialog = this.value;
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  data() {
    return {
      openDialog: false,
      loadingBtn: false,
      notes: null,
    };
  },
  methods: {
    async confirm() {
      try {
        this.loadingBtn = true;
        await API.company.confirmInsuranceCertificate({
          companyId: this.companyId,
          reason: this.notes,
        });

        this.openDialog = false;
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/ConfirmInsuranceModal.vue